<div class="operation-content">
  <div class="operation-controls">
    <div class="mt-1">
      <y42-operation-input-operator-form-control
        [operatorControl]="form.controls.operator!"
        [operatorOptions]="state.operatorOptions"
      ></y42-operation-input-operator-form-control>
    </div>

    <!--absolute date / relative date-->
    <div
      *ngIf="
        (state.operator === Operator.Between ||
          state.operator === Operator.LessThan ||
          state.operator === Operator.Equals ||
          state.operator === Operator.GreaterThan) &&
        showRelativeDates
      "
      class="my-2"
    >
      <mat-button-toggle-group
        [formControl]="form.controls.operator_type!"
        class="toggle-group-deep-style"
        data-test="button-toggle-operator-type"
        (change)="selectOperatorType($event)"
      >
        <mat-button-toggle [value]="OperatorType.Absolute"> Absolute Date</mat-button-toggle>
        <mat-button-toggle [value]="OperatorType.Relative"> Relative Date</mat-button-toggle>
      </mat-button-toggle-group>
    </div>

    <!--relative date format type-->
    <div
      class="flex gap-3"
      *ngIf="
        (state.operator === Operator.Between ||
          state.operator === Operator.LessThan ||
          state.operator === Operator.Equals ||
          state.operator === Operator.GreaterThan) &&
        state.operatorType === OperatorType.Relative
      "
    >
      <div class="ranges grow-0 flex flex-col gap-1 px-2 py-1" *ngIf="state.operator === Operator.Between">
        <div
          class="preset"
          [class.in-use]="state.matchedRelativePreset?.label === preset.label"
          *ngFor="let preset of state.relativePresets; trackBy: trackByDateRangePreset"
          (click)="applyRelativePreset(preset)"
        >
          {{ preset.label }}
        </div>
      </div>
      <div class="grow">
        <div class="mt-1">
          <mat-form-field
            class="w-full no-padding"
            appearance="outline"
            (click)="$event.stopPropagation()"
            [style.fontSize]="'10px'"
          >
            <mat-label>Type</mat-label>
            <mat-select [formControl]="form.controls.value_type!">
              <mat-option
                *ngFor="let operator of operatorValueTypes; trackBy: trackByValueProp"
                class="ag-custom-component-popup"
                [value]="operator.value"
              >
                {{ operator.text }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <!--Relative Value Selectors-->
        <div class="flex items-center gap-2">
          <mat-form-field
            [style.fontSize]="'10px'"
            appearance="outline"
            [ngClass]="state.operator === Operator.Between ? 'w-1/2 md:pr-1' : 'w-full'"
          >
            <mat-label>
              {{ state.operator === Operator.Between ? 'From ' : form.get('value_type')?.value }}
            </mat-label>
            <input
              matInput
              [ngModel]="state.values0"
              type="number"
              autocomplete="off"
              (ngModelChange)="setRelativeDate(0, $event)"
            />
            <div matSuffix class="relative text-gray-700">{{ state.operatorValueTypeLabel }} from now</div>
          </mat-form-field>
          <mat-form-field
            *ngIf="state.operator === Operator.Between"
            [style.fontSize]="'10px'"
            appearance="outline"
            [ngClass]="state.operator === Operator.Between ? 'w-1/2 md:pl-1' : 'w-full'"
          >
            <mat-label>
              {{ state.operator === Operator.Between ? 'To ' : form.get('value_type')?.value }}
            </mat-label>
            <input
              matInput
              [ngModel]="state.values1 || ''"
              type="number"
              autocomplete="off"
              (ngModelChange)="setRelativeDate(1, $event)"
            />
            <span matSuffix class="relative text-gray-700"> {{ state.operatorValueTypeLabel }} from now </span>
          </mat-form-field>
        </div>
      </div>
    </div>

    <!--Date Selector-->
    <div
      class="mt-2"
      *ngIf="
        (state.operator === Operator.Between ||
          state.operator === Operator.LessThan ||
          state.operator === Operator.Equals ||
          state.operator === Operator.GreaterThan) &&
        state.operatorType === OperatorType.Absolute
      "
    >
      <y42-daterange-picker
        panelClass="ag-custom-component-popup"
        class="max-w-[300px]"
        [startDate]="state.initialDates.startDate"
        [endDate]="state.initialDates.endDate"
        [minDate]="state.minDate"
        [maxDate]="state.maxDate"
        [singleDatePicker]="state.operator !== Operator.Between"
        [timePicker]="columnType !== ColumnType.Date"
        [ranges]="state.operator === Operator.Between ? ranges : []"
        (datesChanged)="setDates($event)"
      ></y42-daterange-picker>
    </div>
  </div>

  <y42-operation-input-delete [index]="index" [columnType]="columnType"></y42-operation-input-delete>
</div>

<y42-operation-input-add
  [index]="index"
  [columnType]="columnType"
  [defaultOperator]="state.operatorOptions[0].value"
  [enableMoreConditions]="enableMoreConditions"
></y42-operation-input-add>
